export const SiteLink = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'SitelinkAdExtension',
    },
  },
};
